module.exports = __webpack_public_path__ + "img/person-to-portal.471fffb9.svg";